import React from 'react'
import styles from './button-container.module.css'

const ButtonContainer = ({ isFromUserSocial, children }) => {
  return <div className={`${styles['button-container']} ${isFromUserSocial ? styles['custom-social-card-button-container'] : ''}`}>{children}</div>
}

export default ButtonContainer
